import { connect } from 'react-redux';
import { requestBrandOptions, saveSearchPreferences, requestBrandGroups,searchHotels } from '../modules/tour';

import HotelSearchPrefs from './HotelSearchPrefs';

const mapDispatchToProps = {
  requestBrandOptions,
  saveSearchPreferences,
  requestBrandGroups,
  searchHotels
};

const mapStateToProps = state => ({
  brandList: state.tours.brands,
  tour:state.tours,
  brandGroups: state.tours.brandgroups,
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelSearchPrefs);



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSearchPrefsContainer.js